// extracted by mini-css-extract-plugin
export default {"item":"styles_item__lLxj8","questionContent":"styles_questionContent__J6qeM","question":"styles_question__0ZCR0","answer":"styles_answer__tuL77"};